import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../lib/analytics';

export function usePageTracking(): void {
  const location = useLocation();
  const pageStartTimeRef = useRef<number>(Date.now());
  const lastPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    // Track time spent on previous page
    const now = Date.now();
    const timeSpentSeconds = Math.round((now - pageStartTimeRef.current) / 1000);

    if (timeSpentSeconds > 2 && lastPathRef.current !== location.pathname) {
      analytics.trackPageEngagement(lastPathRef.current, timeSpentSeconds);
    }

    // Reset for new page
    pageStartTimeRef.current = now;
    lastPathRef.current = location.pathname;

    // Track page view for new page
    analytics.trackPageView(
      location.pathname,
      document.title
    );
  }, [location]);
}

// Export analytics instance for event tracking in components
export { analytics };
